import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../interfaces/IIcon";

export const ClockIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M4.467 5.533h.006l-.006.007 1.326 1.326.377-.377L5 5.319V2.6h-.533v2.933Z" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.778 1.674a4 4 0 1 1 4.444 6.652 4 4 0 0 1-4.444-6.652Zm.296 6.209a3.467 3.467 0 1 0 3.852-5.766 3.467 3.467 0 0 0-3.852 5.766Z"
            />
        </SvgIcon>
    );
};
